// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ErrorMessage from '../../../shared/components/error-message';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import ReimbursementSummarySettingsStruct from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-settings';

function handleYellowIndicatorChange(value) {

    const updatedValue = value ?
        parseFloat(value) :
        null;

    this.onYellowIndicatorChange(updatedValue);

}

function handleRedIndicatorChange(value) {

    const updatedValue = value ?
        parseFloat(value) :
        null;

    this.onRedIndicatorChange(updatedValue);

}

const PercentageIndicators = props =>
    <section className='reimbursement-summary-settings-panel'>
        <header>
            <FormattedMessage id='REIMBURSED_PERCENTAGE_INDICATOR'/>
        </header>
        <div className='row'>
            <div className='yellow-indicator'>
                <section className='yellow-percentage'>
                    <FormattedMessage
                        id='SHOW_YELLOW_IF_LESS_THAN'
                        tagName='label'
                    />
                    <FormattedNumberInput
                        allowNegative={false}
                        isValidInput={value => value <= 200}
                        onValueChange={props::handleYellowIndicatorChange}
                        value={props.reimbursementSummarySettings.reimbursedPercentIndicator.yellow}
                    />
                </section>
            </div>
            <div className='red-indicator'>
                <section className='red-percentage'>
                    <FormattedMessage
                        id='SHOW_RED_IF_LESS_THAN'
                        tagName='label'
                    />
                    <FormattedNumberInput
                        allowNegative={false}
                        isValidInput={value => value <= 200}
                        onValueChange={props::handleRedIndicatorChange}
                        value={props.reimbursementSummarySettings.reimbursedPercentIndicator.red}
                    />
                </section>
                <ErrorMessage
                    errorMessage='RED_MUST_BE_LESS_THAN_YELLOW'
                    isValid={props.reimbursementSummarySettings.reimbursedPercentIndicator.yellow > props.reimbursementSummarySettings.reimbursedPercentIndicator.red}
                />
            </div>
        </div>
    </section>;

PercentageIndicators.displayName = 'PercentageIndicators';
PercentageIndicators.propTypes = {
    onRedIndicatorChange: PropTypes.func.isRequired,
    onYellowIndicatorChange: PropTypes.func.isRequired,
    reimbursementSummarySettings: PropTypes.instanceOf(ReimbursementSummarySettingsStruct).isRequired
};

export default PercentageIndicators;



// WEBPACK FOOTER //
// ./src/user/reimbursement-summary-settings/components/percentage-indicators.js